import { ModuleTypeEnum } from '../types/module-type'

export enum SavedQueryVisibilityEnum {
  PRIVATE = 'PRIVATE',
  ORGANIZATION = 'ORGANIZATION',
}

export interface SavedQuery {
  id: string
  organizationId: string
  createdBy: string | null
  name: string
  description: string | null
  query: string
  /** Module types this query targets (e.g. ['TASK']) */
  modules: ModuleTypeEnum[]
  visibility: SavedQueryVisibilityEnum
  createdAt: string | Date
  updatedAt: string | Date
  /** Populated for list views */
  creator?: {
    id: string
    firstName?: string | null
    lastName?: string | null
    email?: string | null
  } | null
}

export interface CreateSavedQueryInput {
  name: string
  description?: string
  query: string
  modules: ModuleTypeEnum[]
  visibility?: SavedQueryVisibilityEnum
}

export interface UpdateSavedQueryInput {
  name?: string
  description?: string | null
  query?: string
  modules?: ModuleTypeEnum[]
  visibility?: SavedQueryVisibilityEnum
}
